var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "20px",
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logos/ cc/AMEX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos/-cc/AMEX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1.000000, 0.000000)",
    fill: "#006FCF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9549291,17.7777111 C30.9549291,18.9999333 29.9655674,19.9999333 28.7563475,19.9999333 L2.19858156,19.9999333 C0.989361702,19.9999333 9.02389274e-13,18.9999333 9.02389274e-13,17.7777111 L9.02389274e-13,2.4386 C9.02389274e-13,1.21637778 0.989361702,0.216377778 2.19858156,0.216377778 L28.7563475,0.216377778 C29.9655674,0.216377778 30.9549291,1.21637778 30.9549291,2.4386 L30.9549291,17.7777111 Z",
    id: "Fill-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "amex_american_express",
    transform: "translate(8.213115, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "3.83606557 19.9672131 3.83606557 9.39344262 22.6557377 9.40983607 22.6557377 12.3278689 20.4754098 14.6557377 22.6557377 17 22.6557377 19.9836066 19.1803279 19.9836066 17.3442623 17.9508197 15.5081967 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F6EB7",
    points: "5.09836066 18.8032787 5.09836066 10.557377 12.0983607 10.557377 12.0983607 12.4590164 7.36065574 12.4590164 7.36065574 13.7540984 11.9836066 13.7540984 11.9836066 15.6229508 7.36065574 15.6229508 7.36065574 16.8852459 12.0983607 16.8852459 12.0983607 18.8032787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F6EB7",
    points: "12.0491803 18.8032787 15.9344262 14.6721311 12.0491803 10.557377 15.0491803 10.557377 17.4098361 13.1803279 19.7868852 10.557377 22.6557377 10.557377 22.6557377 10.6229508 18.8688525 14.6721311 22.6557377 18.6885246 22.6557377 18.8032787 19.7540984 18.8032787 17.3606557 16.1639344 14.9672131 18.8032787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "4.72131148 0.0163934426 9.24590164 0.0163934426 10.852459 3.62295082 10.852459 0.0163934426 16.442623 0.0163934426 17.4098361 2.72131148 18.3770492 0.0163934426 22.6557377 0.0163934426 22.6557377 10.5901639 0.0491803279 10.5901639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57377049,1.16393443 L1.91803279,9.40983607 L4.42622951,9.40983607 L5.1147541,7.75409836 L8.85245902,7.75409836 L9.54098361,9.40983607 L12.1147541,9.40983607 L8.47540984,1.16393443 L5.57377049,1.16393443 L5.57377049,1.16393443 Z M5.8852459,5.90163934 L6.98360656,3.27868852 L8.08196721,5.90163934 L5.8852459,5.90163934 L5.8852459,5.90163934 Z",
    id: "Shape",
    fill: "#2F6EB7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F6EB7",
    points: "12.0819672 9.39344262 12.0819672 1.16393443 15.6229508 1.16393443 17.4262295 6.2295082 19.2622951 1.16393443 22.6557377 1.16393443 22.6557377 9.39344262 20.4754098 9.42622951 20.4754098 3.75409836 18.4098361 9.39344262 16.4098361 9.39344262 14.3114754 3.73770492 14.3114754 9.39344262"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.ddc7e296.svg";
export { ForwardRef as ReactComponent };